module.exports = __webpack_public_path__ + "img/Ramadan2EN.78febf56.png";